import { Link } from 'react-router-dom';
import { cn } from '../../lib/cn';

interface WordmarkProps {
  className?: string;
}

export function Wordmark({ className }: WordmarkProps) {
  return (
    <Link
      to="/"
      aria-label="Send a Secret — home"
      className={cn(
        'group -mx-2 inline-flex items-center gap-2 rounded-md px-2 py-1 text-text transition-colors hover:text-primary',
        'focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary',
        className,
      )}
    >
      <svg
        viewBox="0 0 100 100"
        width="24"
        height="24"
        aria-hidden="true"
        className="text-primary"
      >
        <mask id="whisper-keyhole-wordmark" maskUnits="userSpaceOnUse">
          <rect width="100" height="100" fill="#fff" />
          <circle cx="50" cy="36" r="7" fill="#000" />
          <path d="M47 36 L42 58 H58 L53 36 Z" fill="#000" />
        </mask>
        <path
          d="M26 18 H74 Q86 18 86 30 V54 Q86 66 74 66 H44 L26 82 Q22 84 24 78 L32 66 H26 Q14 66 14 54 V30 Q14 18 26 18 Z"
          fill="currentColor"
          mask="url(#whisper-keyhole-wordmark)"
        />
      </svg>
      <span className="font-display text-base font-medium tracking-tight">Send-a-secret.link</span>
    </Link>
  );
}
